import styled from 'styled-components';

import Cost, { TCostProps } from './Cost';

const StyledCost = styled(Cost)<TCostProps>`
    display: inline-block;
    white-space: nowrap;

    ${p => p.isPreviously && 'text-decoration: line-through;'}
`;

export default StyledCost;
